import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import withState from 'recompose/withState'
import lifecycle from 'recompose/lifecycle'
import withProps from 'recompose/withProps'

import * as EndUserActions from 'app/modules/endUser/actions'
import * as EndUserSelectors from 'app/modules/endUser/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'

import { propertiesOptions } from 'app/modules/endUser/attribute/selectors'
import { fetchAttributes } from 'app/modules/endUser/attribute/actions'

import QuestionAdvancedModal from './component'

const mapStateToProps = state => {
  const question = PlaybookSelectors.getCurrentQuestion(state)
  return {
    questionIndex: question && PlaybookSelectors.getQuestionIndex(state, { id: question.id }),
    FieldAttributes: propertiesOptions(state).toJS(),
    isCreateAttributePending: (attr) => EndUserSelectors.isCreateAttributePending(state, attr),
    question,
    buttonOnlyResponses: PlaybookSelectors.buttonOnlyResponses(state, question.id),
    questionHasKeywordAnswers: PlaybookSelectors.questionHasKeywordAnswers(state, question.id),
    numKeywordsInQuestion: PlaybookSelectors.numKeywordsInQuestion(state, question.id),
    keywordAnswersForQuestion: PlaybookSelectors.keywordAnswersForQuestion(state, question.id),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideQuestionAdvancedModal: PlaybookActions.hideQuestionAdvancedModal,
      setResponse: PlaybookActions.setResponse,
      setFieldAttributeName: PlaybookActions.setFieldAttributeName,
      createPropertyDefinition: EndUserActions.createPropertyDefinition,
      setButtonOnlyResponses: PlaybookActions.setButtonOnlyResponses,
      deleteAnswer: PlaybookActions.deleteAnswer,
      fetchAttributes,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('confirmKeywordsDelete', 'setConfirmKeywordsDelete', false),
  withState('selectedFieldAttribute', 'selectFieldAttribute', undefined),
  withProps(props => ({
    isSelectedAttributeCreatePending: props.isCreateAttributePending(props.selectFieldAttribute)
  })),
  lifecycle({
    componentDidMount() {
      const { actions: { fetchAttributes }, selectFieldAttribute, question } = this.props
      fetchAttributes()
      if (!_.isEmpty(question.fieldConfiguration)) {
        selectFieldAttribute(question.fieldConfiguration.get('fieldName'))
      }
    },
  }),
  withHandlers({
    onNewOptionClick: props => option => {
      const { actions: { createPropertyDefinition }} = props
      if (option) {
        createPropertyDefinition({ name: option.value })
      }
    },
    onCloseClick: props => () => {
      const { actions: { hideQuestionAdvancedModal }} = props
      hideQuestionAdvancedModal()
    },
    onSelectFieldAttribute: props => selection => {
      const value = _.get(selection, 'value', '')
        .toLowerCase()
        .replace(/\s/g, '_')
        .replace(/[^a-z0-9\_]+/g, '')
      if (!!value && value[0] === '_') return false
      const {
        selectFieldAttribute,
        actions: { setFieldAttributeName },
        question: { id: questionId },
      } = props
      selectFieldAttribute(value)
      setFieldAttributeName({ questionId, attribute: value })
    },
    onDeleteAllKeywordResponses: ({ actions: { deleteAnswer }, keywordAnswersForQuestion, question }) => () => {
      keywordAnswersForQuestion.forEach(answer => deleteAnswer({ answerId: answer.id, questionId: question.id }))
    },
    onToggleButtonOnlyResponse: ({ actions: { setButtonOnlyResponses }, question: { id: questionId }}) => evt => {
      setButtonOnlyResponses({ value: evt.target.checked, questionId })
    },
    onFirstDeleteKeywordClick: ({ actions: { deleteAnswer }, numKeywordsInQuestion, setConfirmKeywordsDelete, question, keywordAnswersForQuestion }) => () => {
      if (numKeywordsInQuestion) {
        setConfirmKeywordsDelete(true)
      } else {
        keywordAnswersForQuestion.forEach(answer => deleteAnswer({ answerId: answer.id, questionId: question.id }))
      }
    }
  }),
  withHandlers({
    onNewOptionClick: props => option => {
      const { actions: { createPropertyDefinition }} = props
      if (option) {
        createPropertyDefinition({ name: option.value })
        props.onSelectFieldAttribute(option)
      }
    },
  })
)(QuestionAdvancedModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/QuestionAdvancedModal/index.js